var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecoveryCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.924,
    height: 15.329,
    viewBox: "0 0 12.924 15.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16505",
    "data-name": "Group 16505",
    transform: "translate(-789.538 -496.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(789.538 496.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8334",
    "data-name": "Path 8334",
    d: "M52.772,1.823,46.759.019a.449.449,0,0,0-.258,0l-6.013,1.8a.449.449,0,0,0-.32.43V8.867A4.272,4.272,0,0,0,41.2,11.484a10.7,10.7,0,0,0,2.157,2,19.351,19.351,0,0,0,3.086,1.807.449.449,0,0,0,.367,0A19.351,19.351,0,0,0,49.9,13.482a10.7,10.7,0,0,0,2.157-2,4.272,4.272,0,0,0,1.035-2.617V2.253A.449.449,0,0,0,52.772,1.823Zm-.578,7.044c0,1.522-1.528,2.95-2.809,3.88a19.015,19.015,0,0,1-2.755,1.637,19.015,19.015,0,0,1-2.755-1.637c-1.282-.93-2.809-2.357-2.809-3.88V2.587L46.63.918l5.564,1.669Z",
    transform: "translate(-40.168 0)",
    fill: "#06233d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37364",
    "data-name": "Path 37364",
    d: "M792.618,504.006l1.534,1.534L797.3,502.4",
    transform: "translate(1.044 -0.371)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryCode);
export default __webpack_public_path__ + "static/media/recoveryCode.bb9529c6535d1ed9013bf72ba1ace9e9.svg";
export { ForwardRef as ReactComponent };